<script>
    export let data = {};

    import Button from "../Button.svelte";
    import CheckList from "../CheckList.svelte";
    import DataGrid from "../composites/DataGrid.svelte";
    import DisclosureCard from "../DisclosureCard.svelte";
    import HorizontalRule from "./../presentational/HorizontalRule.svelte";
    import PremiumLogo from "./../presentational/logos/PremiumLogo.svelte";
    import PurchaseProduct from "../composites/PurchaseProduct.svelte";
    import View from "../presentational/View.svelte";
    import { t } from "../../i18n";
    import { processSubscription } from "../../utilities/data-wrangling.js";
    const { subscription, nextBillString, nextBillDate } = processSubscription(data.subscription, false, $t);

    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    const premiumChecklist = {
        title: "Benefits of using AdBlock Premium:",
        link: {
            href: "about:blank",
            text: "Learn More",
        },
        checkItems: [
            "Sync your AdBlock settings across devices",
            "Available for Chrome, Firefox, and Edge ",
            "Replace some ads with for your own images ",
            "Customize AdBlock with exclusive themes",
        ],
    };

    const state = {
        isCancelling: false,
        isPurchasing: false,
    };
    $: isCancelling = state.isCancelling === true;
    $: isPurchasing = state.isPurchasing === true;
    $: isActive = data.product.status === "active";
    const getPlatformSupported = () => true; // TODO: detect plaform :)
    $: isPlatformSupported = getPlatformSupported();

    const productDetails = {
        name: "AdBlock Premium",
        prices: [
            {
                amountString: "1.00",
                recurring: true,
                recurringFrequency: "monthly",
            },
            {
                amountString: "10.00",
                recurring: true,
                recurringFrequency: "yearly",
            },
        ],
        currencies: [
            {
                symbol: "$",
                text: "USD",
            },
            {
                symbol: "£",
                text: "GBP",
            },
            {
                symbol: "€",
                text: "EUR",
            },
        ],
        collapsedPitchString: "Sick premium features at a primo price",
        priceSummaryString: "$1.00 a month or $10 a year",
    };
</script>

{#if isActive}
    <DisclosureCard logoComponent="{PremiumLogo}" isActive="{true}" collapsedDescription="{nextBillString}">
        <View viewType="{'card-wrap'}">
            {#if isCancelling}
                <div class="row justify-content-space-between">
                    <h3>Cancel Subscription</h3>
                </div>
                <HorizontalRule />
                <div class="row">
                    Are you sure you want to cancel? You will have access to {productDetails.name} until {nextBillDate}.
                </div>
                <div class="row collapse-to-col justify-content-flex-end">
                    <Button
                        classNames="{'outline tertiary'}"
                        buttonText="No, keep {productDetails.name}"
                        on:click="{() => (state.isCancelling = false)}"
                    />
                    <Button
                        classNames="{'solid tertiary'}"
                        buttonText="{'Yes, Cancel'}"
                        on:click="{() => dispatch('message', { action: 'CANCEL_SUBSCRIPTION', data })}"
                    />
                </div>
                <HorizontalRule />
            {:else}
                <div class="row justify-content-space-between">
                    <h3>{productDetails.name} Subscription</h3>
                    <a href="/" on:click|preventDefault="{() => (state.isCancelling = true)}">Cancel Subscription</a>
                </div>
                <HorizontalRule />
                <DataGrid data="{subscription}" />
            {/if}
        </View>
        <HorizontalRule />
        <div class="row align-items-center collapse-to-col">
            {#if isPlatformSupported}
                <Button
                    buttonText="{'Download'}"
                    classNames="{'far-right-auto'}"
                    flex="{'0 1 30%'}"
                    on:click="{() => console.log('DOWNLOAD')}"
                />
            {:else}
                <i class="material-icons-outlined">info</i>
                {productDetails.name} is currently available for
                <a href="/">Chrome</a>
                ,
                <a href="/">Firefox</a>
                , and the new
                <a href="/">Edge</a>
                browser.
            {/if}
        </div>
    </DisclosureCard>
{:else if isPurchasing}
    <DisclosureCard logoComponent="{PremiumLogo}" isActive="{false}" isCollapsed="{false}" on:message>
        <PurchaseProduct productDetails="productDetails" />
    </DisclosureCard>
{:else}
    <DisclosureCard
        logoComponent="{PremiumLogo}"
        isActive="{false}"
        collapsedDescription="{productDetails.collapsedPitchString}"
    >
        <View viewType="{'card-wrap'}">
            <CheckList {...premiumChecklist} />
        </View>
        <HorizontalRule />
        <div class="row align-items-center collapse-to-col">
            <i class="material-icons-outlined">credit_card</i>
            $1 a month or $10 a year
            <Button
                buttonText="{'Get AdBlock Premium'}"
                classNames="{'far-right-auto'}"
                flex="{'0 1 30%'}"
                on:click="{() => (state.isPurchasing = true)}"
            />
        </div>
    </DisclosureCard>
{/if}

<style>

</style>
